// app/javascript/controllers/note_filter_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "searchField", "checkbox"]

  connect() {
    // Set up debounce for the search field
    this.timeout = null;
    this.debounceMs = 500;
  }

  checkboxChanged() {
    this.submitForm();
  }

  searchChanged() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.submitForm();
    }, this.debounceMs);
  }

  clearSearch(event) {
    this.searchFieldTarget.value = "";
    this.submitForm()
  }

  submitForm() {
    this.formTarget.requestSubmit();
  }
}